import { Navigate } from "react-router-dom";
import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import { lazy } from "react";
import DataFinancialReportChannelWise from "../Reoprts/data-financial-report-channel-wise";

const ViewContact = Loadable(lazy(() => import("../ContactList/contact-view/view-contact")));
const AllMasksList = Loadable(lazy(() => import("../Mask/mask-list/all-masks-list")));
const Dashboard = Loadable(lazy(() => import("../Dashboard/index")));
const CampaignCreation = Loadable(lazy(() => import("../Campaigns/campaign-create/campaign-create")));
const BlackList = Loadable(lazy(() => import("../BlackList")));
const ManageCampaignsUses = Loadable(lazy(() => import("../Campaigns/campaign-uses/campaign-uses")));
const CampaignView = Loadable(lazy(() => import("../Campaigns/campaign-uses/view-uses/campaign-uses-view")));
const ChildUserList = Loadable(lazy(() => import("../Configurations/userManagement/childUser/child-user-list")));
// const ChannelList = Loadable(lazy(() => import('../Configurations/Channel/channel-list')));
// const RateCardList = Loadable(lazy(() => import('../Configurations/rate-card/rate-cards-list')));
const UnauthorizedAccess = Loadable(lazy(() => import("../../utils/ui-components/UnauthorizedAccess")));
const ManageContactList = Loadable(lazy(() => import("../ContactList")));
const CampaignListReport = Loadable(lazy(() => import("../Reoprts/campaign-list-report")));
const ViewUserPrifile = Loadable(lazy(() => import("../Users/view-profile")));
// const FinancialReport = Loadable(lazy(() => import('../Reoprts/financial-report')));
const FinancialReportChannelWise = Loadable(lazy(() => import("../Reoprts/financial-report-channel-wise")));

function OwnerAuthorizedRoutes(role: any) {
  return [
    {
      path: "/",
      element: <MainLayout role={role} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "campaign",
          children: [
            {
              path: "creation",
              element: <CampaignCreation role={role} />,
            },
            {
              path: "list",
              element: <ManageCampaignsUses />,
            },
            {
              path: "view/:type/:id",
              element: <CampaignView />,
            },
          ],
        },
        {
          path: "contact",
          children: [
            {
              path: "list",
              element: <ManageContactList role={role} />,
            },
            {
              path: "view/:id",
              element: <ViewContact />,
            },
          ],
        },
        {
          path: "mask",
          children: [
            {
              path: "list",
              element: <AllMasksList role={role} />,
            },
          ],
        },
        {
          path: "account-profile",
          element: <ViewUserPrifile />,
        },
        {
          path: "black-list",
          element: <BlackList role={role} />,
        },
        {
          path: "child",
          children: [
            {
              path: "list",
              element: <ChildUserList role={role} />,
            },
          ],
        },
        {
          path: "reports",
          children: [
            {
              path: "campaign-list",
              element: <CampaignListReport />,
            },
            {
              path: "financial-report",
              element: <FinancialReportChannelWise />,
            },
            {
              path: "reward-financial-report",
              element: <DataFinancialReportChannelWise />,
            },
            // {
            //     path: 'financial-report',
            //     element: <FinancialReport/>
            // },
          ],
        },
      ],
    },
    {
      path: "unauthorized",
      element: <UnauthorizedAccess />,
    },
    {
      path: "",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "verify-login",
      element: <Navigate to="/dashboard" />,
    },
    {
      path: "*",
      element: <Navigate to="/unauthorized" />,
    },
  ];
}

export default OwnerAuthorizedRoutes;
